import React, { Component, Fragment } from 'react';
import styled, {css} from 'styled-components'
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import NumberFormat from 'react-number-format';

// Constants
import { constants } from 'constants/index';

export const FieldWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    margin: 10px 0px 10px 0px;
    background: white;
    border-radius: 5px;
    width: 450px;
`
export const InputLabelWrapper = styled.div`
    margin: 0;
    font: 16px Open Sans, Helvetica, sans-serif;
    width: 6vw;
    color: grey;
`
export const InputAreaWrapper = styled.div`
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 10px;
`
export const InputWrapper = styled(NumberFormat)`
    box-sizing: border-box;
    display: block;
    padding: 7px;
    border: none;
    border-bottom: 1px solid lightgray;
    padding-left: 40px;
    font: 16px Open Sans, Helvetica, sans-serif;
    ${props =>
        props.errorMessage && css` border-bottom: 1px solid red;`
    }
    &::placeholder{
        color: ${constants.color.grey34};
    }
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`
export const MainIconWrapper = styled(FontAwesomeIcon)`
    position: absolute;
    top: 4px;
    left: 5px;
    color: ${constants.color.grey5};
`
export const SecondaryIconWrapper = styled(FontAwesomeIcon)`
    position: absolute;
    top: 4px;
    right: 5px;
    color: ${constants.color.grey5};
`

const ValidationMessageWrapper = styled.label`
    /* height: 15px; */
    color: red;
    transition: 0.28s;
    overflow: hidden;
    color: red;
    font-style: italic;
    margin-right: auto;
`

const FormPhoneNumberField = ({
    label,
    name,
    value,
    onfocusout,
    onChange,
    errorMessage,
    inputProps,
    mainIconType,
    secondaryIconType,
    disabled,
    required,
    parent,
    index,
    ...styleProps
}) => {
    return(
        <FieldWrapper style={styleProps.containerProps}>
            <InputAreaWrapper>
                <InputWrapper
                    format="+1 ( ###) ###-####" 
                    mask="_"
                    errorMessage={errorMessage}
                    name={name}
                    onChange={onChange}
                    onBlur={onfocusout}
                    value={value}
                    test-label='input'
                    placeholder={label}
                    style={styleProps.inputStyleProps}
                    disabled={disabled}
                    required={required}
                    parent={parent}
                    index={index}
                    {...inputProps}
                />
                <ValidationMessageWrapper test-label='error-label'>{errorMessage}</ValidationMessageWrapper>

                { mainIconType &&
                    <MainIconWrapper
                        icon={mainIconType}
                        color="black"
                        size="2x"
                        style={styleProps.mainIcon}
                    />
                }

                { secondaryIconType &&
                    <SecondaryIconWrapper
                        icon={secondaryIconType}
                        color="black"
                        size="2x"
                        style={styleProps.secondaryIcon}
                    />
                }

            </InputAreaWrapper>
        </FieldWrapper>
    )
}

FormPhoneNumberField.propTypes = {
    /** Label to be displayed as the title */
    label: PropTypes.string.isRequired,
    /** Name of the field passed in, needed for react state changes */
    name: PropTypes.string.isRequired,
    /** Value of the field */
    value: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired
    ]),
    /** onBlur function used for validation  */
    onfocusout: PropTypes.func,
    /** onChange function to update the value */
    onChange: PropTypes.func,
    /** String that shows if there is an error with the input validation */
    errorMessage: PropTypes.string,
};

FormPhoneNumberField.defaultProps = {
    label: 'Placeholder label',
    name: 'placeholder',
    value: '',
    onfocusout: () => null,
    onChange: () => null,
    errorMessage: null
};

export default FormPhoneNumberField;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/Forms/Components/FormPhoneNumberField.js